import { Pipe, PipeTransform } from '@angular/core';
import { cgpAuthentication } from '../../../modules/cgp-authentication';
import { DatePipe } from '@angular/common';


/**
 * 
 * @param gmin 
 */
const getUserPhotoUrl = (gmin: string) => {
    let _url: string;
    if (gmin) {
        const _path = `${gmin.substr(0, 3)}/${gmin.substr(3, 3)}/${gmin}_lthumb.jpg`;
        _url = 'https://peoplefinder.gm.com/photos/' + _path;
    }
    return _url;
}

/**
* 
*/
@Pipe({ name: 'person' })
export class PersonPipe implements PipeTransform {
    transform(gmin: string) {
        return null;
    }
}


/**
* 
*/
@Pipe({ name: 'userPhoto' })
export class UserPhotoPipe implements PipeTransform {
    transform(data: any, column: any) {
        let response = "";
        const _gmin = data.GMIN ? data.GMIN : data.Gmin ? data.Gmin : data.gmin ? data.gmin : data.OwnerGmin;
        try {
            const url = new PersonPipe()
                .transform(_gmin);
            const image = `<img class="user-photo" src="${url}">`;
            response = `<span>${image}</span>`;
        } catch (e) {
            return _gmin;
        }
        return response;
    }
}

/**
* 
*/
@Pipe({ name: 'userDetail' })
export class UserDetailPipe implements PipeTransform {
    transform(data: any, column: any) {
        let response = "";
        const _gmin = data.GMIN ? data.GMIN : data.Gmin ? data.Gmin : data.gmin ? data.gmin : data.OwnerGmin;
        try {
            const service: any[] = column.template.service.value,
                user = service.find(x => x.GMIN === _gmin);
            const url = new PersonPipe()
                .transform(_gmin);
            const image = `<img class="user-photo" src="${url}">`,
                userDetails = `<span>${user.FirstName} ${user.LastName}</span>`;
            response = `<span>${image}${userDetails}</span>`;
        } catch (e) {
            return _gmin;
        }
        return response;
    }
}


/**
* 
*/
@Pipe({ name: 'activeUser' })
export class ActiveUserPipe implements PipeTransform {
    transform(control: any = undefined) {
        try {
            const user = cgpAuthentication.getUserInfo(),
                gmin = user.gmuniqueidentifier,
                url = getUserPhotoUrl(gmin);
            return user;
        } catch (e) {
            return null;
        }
    }
}


/**
* 
*/
@Pipe({ name: 'fullName' })
export class FullNamePipe implements PipeTransform {
    transform(data: any): string {
        let fn: string;
        if (data && (data.FirstName)) {
            fn = data.FirstName;
            if (data.LastName) fn = `${fn} ${data.LastName}`;
        }
        return fn;
    }
}


/**
* 
*/
@Pipe({ name: 'formControlPipe' })
export class FormControlPipe implements PipeTransform {
    transform(data: any, control: any) {
        let response: any;
        if (control.pipe === 'date') {
            const _date = new DatePipe('en-US')
                .transform(data, control.dateFormat);
            response = `${_date}`;
        } else {
            response = data;
        }
        return response;
    }
}


/**
* A pipe to convert values from imperial to metric
* Convert:
* lb -> kg
* in -> mm
* Use the DecimalPipe to format the result
*/
@Pipe({ name: 'toMetric' })
export class ToMetricPipe implements PipeTransform {
    transform(data: any, control: any): number {
        const value = parseFloat(data);
        let result: any;
        if (!isNaN(value)) {
            switch (control) {
                case "mm":
                    result = data * 25.4;
                    break;
                case "cm":
                    result = data * 2.54;
                    break;
                case "kg":
                    result = data * 0.453592;
                    break;
                default:
                    result = data;
                    break;
            }
        }
        else {
            result = data;
        }

        return result; // format the number to return with only two decimals 
    }
}

/**
* A pipe to convert values from metric to imperial
* Current Conversion:
* kg -> lb
* mm -> in
* Use the DecimalPipe to format the result
*/
@Pipe({ name: 'toImperial' })
export class ToImperialPipe implements PipeTransform {
    transform(data: any, control: any): any {
        const value = parseFloat(data);
        let result: any;
        if (!isNaN(value)) {
            switch (control) {
                case "in":
                    result = data / 25.4;
                    break;
                case "lb":
                    result = data / 0.453592;
                    break;
                default:
                    result = data;
                    break;
            }
        }
        else {
            result = data;
        }

        return result; // format the number to return with only two decimals 
    }
}

@Pipe({ name: 'boolConversion' })
export class BoolConversion implements PipeTransform {
    transform(value: any, control: any): any {
        if (String(value) === "true") {
            return 'Yes'
        }
        else if (String(value) === "false") {
            return 'No'
        }
        else if (control === 'TBD') {
            return 'TBD'
        }
        else {
            return '---'
        }
    }
}

@Pipe({ name: 'doubleConversion' })
export class DoubleConversion implements PipeTransform {
    transform(value: any): string | undefined {
        if (value === 0 || value === null) {
            return '---';
        }
        else if(Number.isInteger(value)){
            return value.toFixed(2);
        }
    }
}

@Pipe({ name: 'doubleSPMConversion' })
export class DoubleSPMConversion implements PipeTransform {
    transform(value: any): any {
        if(Number.isInteger(value)){
            return value.toFixed(2);
        }
        else if (isNaN(value)) return "TBD";
        else return value;
    }
}
